// extracted by mini-css-extract-plugin
export default {"container":"Home_container__Mi89c","page__style":"Home_page__style__7-8wy"};